var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"barcode"},[_c('barcode',{attrs:{"value":_vm.platform_order_sn,"options":{ format: 'EAN-13' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }